import React, { useState, useEffect, useRef } from 'react';

const DatePicker = ({ formData, setBirthDate, isPersonalInfo, setFormValues }) => {

  const [loading, setLoading] = useState(true);
  const [selectedDay, setSelectedDay] = useState(formData?.day || (formData instanceof Date ? formData?.getDate() : 1) ||  1);
  const [selectedMonth, setSelectedMonth] = useState(
    formData?.month ||
    (formData instanceof Date ? formData.getMonth() + 1 : 0) ||
    0
  );
  // const [selectedMonth, setSelectedMonth] = useState(formData?.month || formData?.getMonth() + 1 || 0); // January is 0
  const [selectedYear, setSelectedYear] = useState(formData?.year || (formData instanceof Date ? formData?.getFullYear() : 1975) || 1975);

  // Refs for day, month, and year spinners
  const dayRefs = useRef([]);
  const monthRefs = useRef([]);
  const yearRefs = useRef([]);

  useEffect(() => {
    setSelectedDay(formData?.day || (formData instanceof Date ? formData?.getDate() : 1) );
    setSelectedMonth(formData?.month || (formData instanceof Date ? formData?.getMonth() + 1 : 1));
    setSelectedYear(formData?.year || (formData instanceof Date ? formData?.getFullYear() : 1975));
    
    handleDayScrollToCenter();
    handleMonthScrollToCenter();
    handleYearScrollToCenter();
  }, [formData]);

  // Scroll the selected item into view when day, month, or year changes
  useEffect(() => {
    handleDayScrollToCenter();
  }, [selectedDay, formData?.day, (formData instanceof Date ? formData?.getDate() : 1)]);

  useEffect(() => {
    handleMonthScrollToCenter();
  }, [selectedMonth, formData?.month, (formData instanceof Date ? formData?.getMonth() + 1 : 0)]);

  useEffect(() => {
    handleYearScrollToCenter();
  }, [selectedYear, formData?.year, (formData instanceof Date ? formData?.getFullYear() : 1975)]);

  const handleDayScrollToCenter = () => {
    if (dayRefs.current[selectedDay - 1]) {
      dayRefs.current[selectedDay - 1].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  }
  const handleMonthScrollToCenter = () => {
    if (monthRefs.current[selectedMonth]) {
      monthRefs.current[selectedMonth].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  }
  const handleYearScrollToCenter = () => {
    if (yearRefs.current[selectedYear - 1975]) {
      yearRefs.current[selectedYear - 1975].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  }

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 105;

  // Arrays for day, month, and year
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [{name:'January', id:1}, 
    {name:'February', id:2}, 
    {name:'March', id:3}, 
    {name:'April', id:4}, 
    {name:'May', id:5}, 
    {name:'June', id:6}, 
    {name:'July', id:7}, 
    {name:'August', id:8}, 
    {name:'September', id:9}, 
    {name:'October', id:10}, 
    {name:'November', id:11}, 
    {name:'December', id:12}
    // "January", "February", "March", "April", "May", "June", "July",
    // "August", "September", "October", "November", "December"
  ];
  // const years = Array.from({ length: 50 }, (_, i) => 1975 + i);
  const years = Array.from({ length: currentYear - minYear + 1 }, (_, i) => minYear + i);

  const handleDayChange = (day) => {
    setSelectedDay(day);
    if(isPersonalInfo){
      setBirthDate((prev) => ({ ...prev, ['day']: day }));
    }
    if (formData) {
      formData.day = day;
    }
  };
  useEffect(() => {
    if(selectedDay){
      if (formData) {
        formData.day = selectedDay;
      }
    }
  }, [selectedDay, setSelectedDay])

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    if(isPersonalInfo){
      setBirthDate((prev) => ({ ...prev, ['month']: month }));
    }
    if (formData) {
      formData.month = month;
    }
  };

  const handleYearChange = (year) => {
    if(isPersonalInfo){
      setBirthDate((prev) => ({ ...prev, ['year']: year }));
    }
    setSelectedYear(year);
    if (formData) {
      formData.year = year;
    }
  };

  // Simulate a loading spinner
  setTimeout(() => setLoading(false), 50);

  // Helper function to determine the opacity class
  const getOpacityClass = (index, selectedIndex) => {
    const isNearSelected = Math.abs(index - selectedIndex) <= 1;
    return isNearSelected ? "opacity-1" : "opacity-0-5";
  };

  return (
    <div>
      <div className="date-picker-container">
        {loading ? (
          <div className="spinner"></div>
        ) : (
          <div>
            <div className="date-picker">
              <div className="date-column">
                {days.map((day) => (
                  // ${getOpacityClass(day - 1, selectedDay - 1)}
                  <div
                    key={day}
                    className={`date-item ${day === selectedDay ? 'selected opacity-1' : 'opacity-0-5'}`}
                    onClick={() => handleDayChange(day)}
                    ref={(el) => (dayRefs.current[day - 1] = el)}
                  >
                    {day.toString().padStart(2, "0")}
                  </div>
                ))}
              </div>
              <div className="date-column">
                {months.map((month, index) => (
                  // ${getOpacityClass(index, selectedMonth)}
                  <div
                    key={month.id}
                    className={`date-item ${month.id === selectedMonth ? 'selected opacity-1' : 'opacity-0-5'}
                      `}
                    onClick={() => handleMonthChange(month?.id)}
                    ref={(el) => (monthRefs.current[index] = el)}
                  >
                    {month?.name}
                  </div>
                ))}
              </div>
              <div className="date-column">
                {years.map((year, index) => (
                  // ${getOpacityClass(year - 1975, selectedYear - 1975)}
                  <div
                    key={year}
                    className={`date-item ${year === selectedYear ? 'selected opacity-1' : 'opacity-0-5'}
                      `}
                    onClick={() => handleYearChange(year)}
                    ref={(el) => (yearRefs.current[year - 1975] = el)}
                  >
                    {year}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      
    </div>
  );
};

export default DatePicker;
